import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { isUserPendingDeletion } from './guard-auth.util';

/**
 * Prevents users who are in PENDING_DELETION state from navigating normal application pages.
 * Redirects them directly to the /auth/pending-deletion grace-period portal.
 */
export const pendingDeletionBlockGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.currentUser();
  if (isUserPendingDeletion(user)) {
    return router.createUrlTree(['/auth/pending-deletion']);
  }

  return true;
};

/**
 * Protects the /auth/pending-deletion page so only users currently in PENDING_DELETION can view it.
 * Active users or unauthenticated visitors are redirected to home / login.
 */
export const pendingDeletionPageGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.currentUser();
  const token = localStorage.getItem('token');

  if (!token || !user) {
    return router.createUrlTree(['/auth/login']);
  }

  if (!isUserPendingDeletion(user)) {
    return router.createUrlTree(['/']);
  }

  return true;
};
